import React, { useState, useEffect } from 'react';
import { Row, Col, Label, Form, Card, CardBody } from 'reactstrap';
import { useForm } from 'react-hook-form';

const PreEventFeedbackFormV2 = ({ formSubmit, onPrevious, data }) => {
    const {
        register,
        formState: { errors },
        watch,
        handleSubmit,
        getValues,
        setValue
    } = useForm({
        mode: "onBlur",
    });

    const fields = [
        "rate_award_gala",
        "describe_evening",
        "hightlight_of_the_night",
        "short_of_expectations"
    ];

    const submit = (response) => {
        formSubmit(response);
    }

    useEffect(() => {
        fields.map(field => setValue(field, data[field]));
    }, []);

    return (
        <Form onSubmit={handleSubmit(submit)}>
            {/* Rating (scale 1–5) */}
            <Card className="mb-4">
                <CardBody className="pb-3">
                    <Label className='my-1' style={{ fontWeight: '600' }}>
                        Rating (scale 1–5)
                    </Label>
                    <br />

                    {/* rate_award_gala */}
                    <Label className='my-2'>
                        Overall, how would you rate the awards gala evening? <span className="asterisk_red">*</span>
                    </Label>
                    <input
                        type="number"
                        max="5"
                        min="1"
                        {...register("rate_award_gala", {
                            required: "This field is required",
                            min: {
                                value: 1,
                                message: "Minimum rating is 1"
                            },
                            max: {
                                value: 5,
                                message: "Maximum rating is 5"
                            }
                        })}
                        className={`form-control ${errors.rate_award_gala ? "form-invalid mb-0" : "mb-0"}`}
                    />
                    {errors.rate_award_gala ? <p role="alert" className="invalid-feedback mb-0">{errors.rate_award_gala.message}</p> : null}
                </CardBody>
            </Card>

            {/* Open-ended */}
            <Card className="mb-4">
                <CardBody className="pb-3">
                    <Label className='my-1' style={{ fontWeight: '600' }}>
                        Open-ended
                    </Label>
                    <br />

                    {/* describe_evening */}
                    <Label className='my-2'>
                        In three words, how would you describe the evening? <span className="asterisk_red">*</span>
                    </Label>
                    <textarea
                        {...register("describe_evening", {
                            required: "This field is required"
                        })}
                        className={`form-control ${errors.describe_evening ? "form-invalid mb-0" : "mb-0"}`}
                    />
                    {errors.describe_evening ? <p role="alert" className="invalid-feedback mb-0">{errors.describe_evening.message}</p> : null}

                    {/* hightlight_of_the_night */}
                    <Label className='mb-2 mt-3'>
                        What was the highlight of the night for you? <span className="asterisk_red">*</span>
                    </Label>
                    <textarea
                        {...register("hightlight_of_the_night", {
                            required: "This field is required"
                        })}
                        className={`form-control ${errors.hightlight_of_the_night ? "form-invalid mb-0" : "mb-0"}`}
                    />
                    {errors.hightlight_of_the_night ? <p role="alert" className="invalid-feedback mb-0">{errors.hightlight_of_the_night.message}</p> : null}

                    {/* short_of_expectations */}
                    <Label className='mb-2 mt-3'>
                        What, if anything, fell short of expectations? <span className="asterisk_red">*</span>
                    </Label>
                    <textarea
                        {...register("short_of_expectations", {
                            required: "This field is required"
                        })}
                        className={`form-control ${errors.short_of_expectations ? "form-invalid mb-0" : "mb-0"}`}
                    />
                    {errors.short_of_expectations ? <p role="alert" className="invalid-feedback mb-0">{errors.short_of_expectations.message}</p> : null}
                </CardBody>
            </Card>

            <Row>
                <Col md="6" className="text-left mt-3">
                </Col>
                <Col md="6" className="text-right mt-3">
                    <button className="form-btn inline-block w-50 newbuttontheme text-white submit-btn" type="submit">NEXT</button>
                </Col>
            </Row>
        </Form>
    )
}

export default PreEventFeedbackFormV2;